import { render } from "./PriorityConfigurationsVendorSelector.vue?vue&type=template&id=bb80a250"
import script from "./PriorityConfigurationsVendorSelector.vue?vue&type=script&lang=js"
export * from "./PriorityConfigurationsVendorSelector.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/payment-hub-web-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__